import { ActiveUser, DomainGroup, RoleAssignment } from '@bmwe/data';
import {
  GroupFragment,
  MeFragment,
  RoleAssignmentFragment,
} from '@bmwe/data/kwg/graphql';

export function toActiveUser(me: MeFragment): ActiveUser {
  return {
    id: me.id,
    name: me.name,
    email: me.email,
    signatureInitials: me.signatureInitials,
    roleAssignments: me.roleAssignments?.nodes?.map(toRoleAssignment) ?? [],
    groups: me.groups?.nodes?.map(toDomainGroup) ?? [],
  };
}

export function toRoleAssignment(
  assignment: RoleAssignmentFragment,
): RoleAssignment {
  return {
    id: assignment.id,
    roleType: assignment.roleType ?? undefined,
    userId: assignment.userId ?? undefined,
    objectType: assignment.objectType ?? undefined,
    dossierId: assignment.dossierId ?? undefined,
  };
}

export function toDomainGroup(group: GroupFragment): DomainGroup {
  return {
    id: group.id,
    name: group.name,
    roleAssignments: group.roleAssignments?.nodes?.map(toRoleAssignment) ?? [],
  };
}
